export enum SocialApplyStatus {
  PROPOSED = "proposed",
  INTERESTED_CANDIDATE = "interestedCandidate",
  PRESCRIPTION_FILLED = "prescriptionFilled",
  INTEGRATED_CANDIDATE = "integratedCandidate",
  REFUSED_STRUCTURE = "refusedStructure",
  REFUSED_CANDIDATE = "refusedCandidate",
}

export enum ProposalType {
  MANUAL = "manual",
  EMAIL = "email",
  SMS = "sms",
}

export enum PartnerDecision {
  INTEGRATED = "integrated",
  NOT_INTEGRATED = "notIntegrated",
}

export enum PartnerDecisionCause {
  NOT_IN_RSA_PLAN = "notInRSAPlan",
  HAS_JOB = "hasJob",
  OUTSIDE_TERRITORY = "outsideTerritory",
  HAS_MOVED = "hasMoved",
  NO_ANSWER = "noAnswer",
  BENEFICIARY_REFUSAL = "beneficiaryRefusal",
}

export enum PartnerDecisionReason {
  EXCUSED_ABSENCE = "excusedAbsence",
  UNEXCUSED_ABSENCE = "unexcusedAbsence",
}
